<template>
  <div class="training-page">
    <el-card shadow="never" class="table-card">
      <div class="toolbar">
        <span class="toolbar-title">培训列表</span>
        <el-button size="small" icon="el-icon-refresh" @click="fetchList">刷新</el-button>
      </div>

      <el-table
        v-loading="loading"
        :data="list"
        class="train-table"
        empty-text="暂无培训"
        @row-click="goCourse"
      >
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="tr_xx_title" label="标题" min-width="220" show-overflow-tooltip />
        <el-table-column label="日期" min-width="180">
          <template slot-scope="scope">
            <div class="date-main">
              <span class="date-label">开课</span>{{ scope.row.tr_xx_k_date || '-' }}
            </div>
            <div v-if="scope.row.tr_xx_face_date" class="date-sub">
              <span class="date-label">面授</span>{{ scope.row.tr_xx_face_date }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="学习状态" width="130" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusOf(scope.row).type" size="small">
              {{ statusOf(scope.row).text }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getTrainingList } from '../api'

export default {
  name: 'TrainingList',
  data() {
    return {
      loading: false,
      list: []
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await getTrainingList()
        this.list = Array.isArray(res) ? res : []
      } catch (e) {
        this.$message.error('获取培训列表失败')
      } finally {
        this.loading = false
      }
    },
    statusOf(row) {
      const steps = row.steps || []
      if (!steps.length) return { text: '未开始', type: 'info' }
      const done = steps.filter(s => s.status === 'completed').length
      if (done === steps.length) return { text: '已完成', type: 'success' }
      if (done > 0) return { text: '学习中', type: 'warning' }
      return { text: '未开始', type: 'info' }
    },
    goCourse(row) {
      this.$router.push({
        path: '/course',
        query: { id: row.id, title: row.tr_xx_title }
      })
    }
  }
}
</script>

<style scoped>
.training-page {
  max-width: 100%;
  margin: 0 auto;
}

.table-card {
  border: none;
  border-radius: 8px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.toolbar-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.train-table {
  width: 100%;
}

.train-table ::v-deep .el-table__row {
  cursor: pointer;
}

.date-main,
.date-sub {
  font-size: 13px;
  color: #606266;
}

.date-sub {
  margin-top: 2px;
  color: #909399;
}

.date-label {
  display: inline-block;
  width: 38px;
  color: #c0c4cc;
}
</style>
